import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/services/globals';
import { DoctorsService } from 'src/app/sas/services/doctors.service';
import { Doctor } from '../../shared/models/DTO/Doctor';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-doctors',
  templateUrl: './doctors.component.html',
  styleUrls: ['./doctors.component.css']
})
export class DoctorsComponent implements OnInit {

  constructor(private router: Router,public global: Globals,translate: TranslateService,
              public _DoctorService : DoctorsService ,private _activatedRoute:ActivatedRoute,private toastr: ToastrService ) {
    translate.setDefaultLang('AR');
  }

  subSpeciality :string;
  subSpecialityId :any;
  doctors : Doctor [] = [];

  ngOnInit() {
    this.subSpeciality = new URLSearchParams (window.location.search).get('subSpeciality'); // from (query string)
    this._activatedRoute.params.subscribe(a => this.subSpecialityId = a['subSpecialityId']); // from (route)
    if(this.subSpecialityId){
      this.getDoctors();
    }
  }

  getDoctors(){
    this._DoctorService.GetDoctorsBySubSpecialityId(this.subSpecialityId).subscribe(
      (data:any) => {
        console.log("doctors :",data.data);
        if(data.status !=-1){
          this.doctors = data.data;
        }
        else{
          this.toastr.error('لم يتم العثور على المتخصصين.');
        }
        this.global.spinner = false;
      },
      (error:any) =>{
        console.log(error);
        this.toastr.error('حدث خطأ ما');
        this.global.spinner = false;
      });
  }

}
